import { FaDraftingCompass, FaHardHat, FaPencilRuler } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import thumb1 from "../../assets/img/vision.jpg";
import thumb2 from "../../assets/img/mission.jpg";
import thumb3 from "../../assets/img/approch3.jpg";


const approchData = [
  {
    id: uuidv4(),
    thumb: thumb1,
    icon: <FaDraftingCompass />,
    heading: "Our Vision",
    text: "To become a trusted engineering and manufacturing solutions partner for global customers by providing innovative, cost-effective, and high-quality manufacturing solutions.",
    btnText: "Read More",
    // pageLink: "/",
  },

  {
    id: uuidv4(),
    thumb: thumb2,
    icon: <FaPencilRuler />,
    heading: "Our Mission",
    text: "To support customers from product development to mass production with quality, cost-effective, and reliable engineering and manufacturing solutions.",
    btnText: "Read More",
    // pageLink: "/",
  },

  // {
  //     id: uuidv4(),
  //     thumb: thumb3,
  //     icon: <FaHardHat />,
  //     heading: 'Our Approch',
  //     text: 'Lorem ipsum dolor sit amet, consectet ur adipisicing elit, sed do eiusmod',
  //     btnText: 'Read More',
  //     pageLink: '/project-details',
  // },
];

export default approchData;
